<template>
<nav class="navbar navbar-expand-lg navbar-light p-0">
    <div class="inside">
        <!-- Logos -->
        <div v-show="!model.expandSearch" @click="clickLogo()" class="logos">
            <img id="companias-logo" :src="model.logo1Url" />
            <img id="cb-logo" :src="model.logo2Url" />
        </div>
        <!-- Botones y usuario -->
        <div v-show="!model.expandSearch" class="derecha">
            <!-- Usuario autorizado -->
            <div class="usuario">
                <span>{{ clienteName }}</span>
            </div>
            <div class="botones">
                <div class="busqueda">
                    <!-- Pantallas chicas -->
                    <div class="busqueda-chica">
                        <button
                        @click="clickSmallSearch()"
                        type="button"
                        class="btn btn-link boton"
                        >
                            <div class="iconos">
                                <font-awesome-icon :icon="Icons.BUSCAR" />
                            </div>
                        </button>
                    </div>
                    <!-- Pantallas grandes -->
                    <div class="busqueda-grande">
                        <form @submit.prevent="search()">
                            <div class="input-group">
                            <input
                                v-model="model.search"
                                type="search"
                                class="form-control"
                                placeholder="Buscar"
                                aria-label="Buscar"
                                aria-describedby="icono-buscar"
                            />
                            <button class="input-group-text" type="submit">
                                <font-awesome-icon :icon="Icons.BUSCAR" />
                            </button>
                            </div>
                        </form>
                    </div>
                </div>
                <!--Suscripciones-->
                <div class="suscripciones">
                    <button
                    @click="clickOpenSuscripcionListModal()"
                    type="button"
                    class="btn btn-link boton"
                    >
                    <div class="iconos">
                        <img src="img/logo-regalo.png" />
                    </div>
                    <span class="label">MIS CUPONES</span>
                    </button>
                </div>
                <div class="autorizacion">
                    <!-- Salir -->
                    <div class="salir">
                    <button
                        @click="clickExit()"
                        type="button"
                        class="btn btn-link boton"
                    >
                        <div class="iconos">
                        <font-awesome-icon class="flecha" :icon="Icons.APP_ICON_3" />
                        </div>
                        <span class="label">SALIR</span>
                        <!-- </router-link> -->
                    </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Buscador -->
        <div v-show="model.expandSearch" class="busqueda-expandida">
            <button
            @click="clickCancelSmallSearch()"
            type="button"
            class="btn btn-link boton"
            >
                <div class="iconos">
                    <font-awesome-icon :icon="Icons.ATRAS" />
                </div>
            </button>
            <form @submit.prevent="search()">
                <div class="input-group">
                    <input
                    v-model="model.search"
                    type="search"
                    class="form-control"
                    placeholder="Buscar"
                    aria-label="Buscar"
                    aria-describedby="icono-buscar"
                    />
                    <button class="input-group-text" type="submit">
                        <font-awesome-icon :icon="Icons.BUSCAR" />
                    </button>
                </div>
            </form>
        </div>
    </div>
</nav>
</template>
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { Icons as IconConstants } from "../../../constants";
import { environment } from "../../../environments/environment";

const SEARCH_EVENT = "buscar";
const SUSCRIPCION_LIST_EVENT = "suscripciones";

export default {
components: {
    FontAwesomeIcon
},
props:{
    clienteName: String,
    logoUrl: String,
},
data(){
    return{
        model:{
            expandSearch: false,
            logo1Url: 
            localStorage.getItem('logoCompania') ? 
            environment.API_SB_URL + 'images/logos/' + localStorage.getItem('logoCompania')
            : "img/logo-sumabeneficios-06.png",
            logo2Url: "img/club de descuentos-06.svg",
            clienteName: undefined,
            search: '',
        }
    }
},
computed:{
    Icons() {
      return IconConstants;
    },
},
watch:{
    clienteName(value){
        this.model.clienteName = value;
    },
    logoUrl(value){
        this.model.logo1Url = value;
    }
},
methods:{
    clickExit(){
      localStorage.removeItem("dni");
      localStorage.removeItem("token");
      localStorage.removeItem("idUser");
      localStorage.removeItem("iduser");
      localStorage.removeItem("user");
      localStorage.removeItem("usersb");
      localStorage.removeItem("logoCompania");

      this.$router.push({ name: "InicioLogin", params: { volver: true } });
    },
    clickOpenSuscripcionListModal(){
      this.$emit(SUSCRIPCION_LIST_EVENT);
    },
    clickSmallSearch(){
        this.model.expandSearch = true;
    },
    clickCancelSmallSearch(){
        this.model.expandSearch = false;
    },
    clickLogo() {
        if(this.$router.currentRoute.path != '/'){
            // Go home
            this.$router.push("/");
        }
    },
    search(){
        if (this.model.search) {
            this.$emit(SEARCH_EVENT, this.model.search);
            this.$router.push("/home/buscar/" + this.model.search);
        }
    }
}
}
</script>
<style scoped>
* {
  font-size: 11px;
}

.navbar {
  z-index: 1000;
  background: var(--color-estructura-a);
  padding: 0 !important;
  height: 75px;
  width: -moz-available;
  width: -webkit-fill-available;

  -moz-box-shadow: 0 5px 5px rgb(0 0 0 / 75%);
  -webkit-box-shadow: 0 5px 5px rgb(0 0 0 / 75%);
  box-shadow: 0 5px 5px rgb(0 0 0 / 75%);
}

.sombra-navbar {
  height: 75px;
  width: 99.5%;
  display: flex;
  position: absolute;
  box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.75);
  z-index: 15;
  top: 0;
  margin-left: 0.3%;
}

.navbar > .inside{
    width: 100%;
    display: flex;
    justify-content: space-between;
}

/** Logos y no-logos */
.logos,
.derecha {
  display: flex;
  align-items: center;
}

.logos {
  width: 200px;
  cursor: pointer;
}

.logos img {
  max-width: 40%;
  margin-left: 10px;
}

.derecha {
  flex-direction: column;
}

.botones {
  width: 100%;
  height: 60px;
  max-width: 600px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.boton {
  display: flex;
  flex-direction: column;
}

a,
.boton {
  color: white !important;
  cursor: pointer;
  text-decoration: none;
}

.boton:hover,
a:hover {
  color: var(--color-estructura-c) !important;
  transition-duration: 0.3s;
  transition-timing-function: ease;
}

.boton .iconos {
  margin: auto;
  display: flex;
}

.iconos * {
  font-size: 13px;
}

.iconos img {
  width: 13px;
}

.iconos img:hover {
  border-bottom: 2px solid var(--color-estructura-c);
  transition-duration: 0.3s;
  transition-timing-function: ease;
}

.label {
  display: block;
}

.busqueda-chica {
  display: none;
}

.busqueda-expandida {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.busqueda-grande {
  display: flex;
}

.usuario {
  width: 100%;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: center;
}

.usuario span {
  color: white;
  font-style: italic;
}

.salir {
  margin-right: 10px;
}

/* ************************************************************************ */
/* ************************************************************************ */
/* ******************* Media Queries ************************************** */
/* ************************************************************************ */
/* ************************************************************************ */

/* Extra small devices (portrait phones, less than 576px) */
@media screen and (max-width: 575px) {
  * {
    font-size: 11px;
  }

  .navbar {
    height: 60px;
  }

  .sombra-navbar {
    height: 60px;
    z-index: 15;
  }

  .logos {
    width: 80px;
  }

  .logos img {
    max-width: 90%;
    margin: 0;
  }

  #cb-logo {
    display: none;
  }

  .botones {
    height: 45px;
  }

  .iconos * {
    font-size: 16px;
  }

  .iconos img {
    width: 16px;
  }

  .label {
    display: none;
  }

  .busqueda-chica {
    display: unset;
  }

  .busqueda-grande {
    display: none;
  }

}

/* Small devices (landscape phones, less than 768px) */
@media screen and (min-width: 576px) and (max-width: 767px) {
  .logos {
    width: 150px;
  }

  .logos img {
    max-width: 70%;
    margin: 0;
  }

  #cb-logo {
    display: none;
  }
}

/* Medium devices (tablets, less than 992px) */
@media screen and (min-width: 767px) and (max-width: 991px) {
  .logos {
    width: 250px;
  }
}
</style>